/* La cesta lateral, sin salir de la página (Dani, 13/10).
   Acompaña a sections/cart-drawer: añade por la Ajax Cart API desde cualquier
   formulario de producto que NO sea de la compra rápida, y repinta con el
   Liquid que devuelve Shopify el contador de la cabecera (sección
   `cart-count`, la misma que usa assets/lny-quick-buy.js) y la cesta lateral.

   Reparto con lo demás, para no pisarse:
     · assets/lny-quick-buy.js añade desde las tarjetas y su cajón; al ir bien
       lanza `lny:cart-updated` y `lny:cart-added`, y la cesta lateral se abre.
     · assets/lny-cart.js es solo de la página /cart, donde no hay cajón.
     · Este archivo se queda con el resto: la ficha, la barra fija de móvil y
       la tarjeta de compra de la receta.

   El formulario sigue siendo el nativo de Shopify: sin JS, o si la petición
   falla (agotado, sin red), se envía como siempre y lleva a la página de la
   cesta, que es donde Shopify cuenta el error.

   Hacia fuera:
     window.lnyCart.request(url, formData)  petición a /cart/*.js
     window.lnyCart.refresh()               volver a pedir lo pintado
     window.lnyCart.shippingRates(url, dir) tarifas de envío para una dirección
     evento `lny:cart-updated`              la cesta cambió (detail.sections)
     evento `lny:cart-added`                además, se acaba de añadir algo */
(() => {
  const FORM = 'form[action$="/cart/add"]';
  /* Los de la compra rápida son de lny-quick-buy.js */
  const QUICK_BUY = 'form.quick-buy-form, form[data-quick-buy-form]';
  const COUNT = '[data-cart-count]';
  const COUNT_SECTION = 'cart-count';
  const DRAWER_SECTION = 'cart-drawer';
  const DONE_MS = 1800;

  const live = () => document.querySelector('[data-cart-live]');

  /* Las secciones que hay que repintar tras un cambio */
  const sectionIds = () => {
    const ids = [COUNT_SECTION];
    if (document.querySelector('[data-cart-drawer]')) ids.push(DRAWER_SECTION);
    return ids;
  };

  /* El contador sale del Liquid de la sección `cart-count` */
  const paintCount = (html) => {
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(COUNT);
    if (!fresh) return;
    document.querySelectorAll(COUNT).forEach((el) => {
      el.innerHTML = fresh.innerHTML;
    });
  };

  const applied = (data) => {
    if (data.sections) paintCount(data.sections[COUNT_SECTION]);
    document.dispatchEvent(new CustomEvent('lny:cart-updated', { detail: data }));
    return data;
  };

  const request = (url, body) => {
    const ids = sectionIds();
    if (ids.length) {
      body.append('sections', ids.join(','));
      body.append('sections_url', window.location.pathname);
    }
    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body,
    })
      .then((response) =>
        response.json().then((data) => {
          /* Shopify explica el rechazo (p. ej. no queda stock) en description */
          if (!response.ok) throw Object.assign(new Error('cart ' + response.status), data);
          return data;
        })
      )
      .then(applied);
  };

  const refresh = () => {
    const ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    /* Sin cabecera Accept a propósito: pidiendo JSON, una ficha contesta con el
       JSON del PRODUCTO y no con las secciones */
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')))
      .then((response) => {
        if (!response.ok) throw new Error('sections ' + response.status);
        return response.json();
      })
      .then((sections) => applied({ sections }));
  };

  /* Lo que costaría enviar la cesta actual a una dirección, según las tarifas
     de la tienda. Shopify pide país, código postal y provincia. */
  const shippingRates = (url, address) => {
    const query = new URLSearchParams();
    Object.keys(address).forEach((key) => query.append('shipping_address[' + key + ']', address[key]));
    return fetch(url + '?' + query)
      .then((response) => {
        if (!response.ok) throw new Error('shipping ' + response.status);
        return response.json();
      })
      .then((data) => data.shipping_rates || []);
  };

  window.lnyCart = { request, refresh, shippingRates };

  /* El nodo de texto del botón (el label va suelto, entre el ripple y el badge) */
  const labelNode = (btn) =>
    [...btn.childNodes].find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '');

  const showDone = (btn) => {
    const box = live();
    const doneText = box ? box.dataset.added : '';
    const svg = btn.querySelector(':scope > svg');
    const text = labelNode(btn);
    let restore = () => {};

    if (svg) {
      const check = document.querySelector('template[data-cart-check]');
      if (check) {
        const icon = check.content.firstElementChild.cloneNode(true);
        svg.replaceWith(icon);
        restore = () => icon.replaceWith(svg);
      }
    } else if (text && doneText) {
      const before = text.textContent;
      text.textContent = doneText;
      restore = () => {
        /* Si la ficha cambió el label mientras tanto (otro formato), manda ella */
        if (text.textContent === doneText) text.textContent = before;
      };
    }

    if (box && doneText) {
      box.textContent = '';
      requestAnimationFrame(() => { box.textContent = doneText; });
    }
    window.setTimeout(restore, DONE_MS);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(FORM) || form.matches(QUICK_BUY)) return;
    if (event.defaultPrevented || !window.fetch || !window.FormData) return;

    const btn = event.submitter || form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }
    event.preventDefault();

    if (btn) btn.setAttribute('aria-busy', 'true');

    request(form.action + '.js', new FormData(form))
      .then((data) => {
        if (btn) showDone(btn);
        document.dispatchEvent(new CustomEvent('lny:cart-added', { detail: data }));
      })
      .catch(() => {
        /* Envío nativo: form.submit() no vuelve a pasar por aquí */
        form.submit();
      })
      .finally(() => {
        if (btn) btn.removeAttribute('aria-busy');
      });
  });
})();
